import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import { InputDate } from 'components/fields'

export default class AwardRegistrationDate extends Component {
  render() {
    return (
      <div className="row">
        <div className="col-xs-6">
          <InputDate
            label="Registration approval date"
            intlKey="label.registration_approval_date"
            name="registrationDate"
            disabled
          />
        </div>
        <div className="col-xs-6">
          <InputDate
            label="Start date"
            intlKey="label.start_date"
            name="startDate"
          />
        </div>
      </div>
    )
  }
}
